import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import type { FunnelStep } from '../../data/analyticsStore';
interface FunnelChartProps {
  data: FunnelStep[];
}
function CustomTooltip({
  active,
  payload
}: any) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload as FunnelStep;
  return <div className="rounded-lg border border-white/10 bg-[#0c1222] px-4 py-3 shadow-xl" data-id="element-19">
      <p className="font-body text-sm font-semibold text-white" data-id="element-20">{d.name}</p>
      <p className="mt-1 font-body text-xs text-white/60" data-id="element-21">
        Visitantes: <span className="text-cyan-400 font-medium" data-id="element-22">{d.count}</span>
      </p>
      <p className="font-body text-xs text-white/60" data-id="element-23">
        CTR:{' '}
        <span className="text-cyan-400 font-medium" data-id="element-24">{d.ctr.toFixed(1)}%</span>
      </p>
      <p className="font-body text-xs text-white/60" data-id="element-25">
        Del total:{' '}
        <span className="text-white/80" data-id="element-26">{d.percentOfTotal.toFixed(1)}%</span>
      </p>
    </div>;
}
export function FunnelChart({
  data
}: FunnelChartProps) {
  if (!data.length) return null;
  const maxCount = Math.max(...data.map(d => d.count), 1);
  return <div className="rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-5" data-id="element-27">
      <h3 className="font-body text-sm font-semibold text-white mb-4" data-id="element-28">
        Embudo del Quiz
      </h3>
      <div className="h-72" data-id="element-29">
        <ResponsiveContainer width="100%" height="100%" data-id="element-30">
          <BarChart data={data} margin={{
          top: 4,
          right: 4,
          bottom: 4,
          left: 4
        }} data-id="element-31">
            <XAxis dataKey="name" tick={{
            fill: 'rgba(255,255,255,0.4)',
            fontSize: 11
          }} axisLine={false} tickLine={false} interval={0} angle={-45} textAnchor="end" height={50} data-id="element-32" />
            <YAxis tick={{
            fill: 'rgba(255,255,255,0.4)',
            fontSize: 11
          }} axisLine={false} tickLine={false} width={36} data-id="element-33" />
            <Tooltip content={<CustomTooltip data-id="element-35" />} cursor={{
            fill: 'rgba(255,255,255,0.03)'
          }} data-id="element-34" />
            <Bar dataKey="count" radius={[4, 4, 0, 0]} data-id="element-36">
              {data.map((entry, i) => {
              const ratio = entry.count / maxCount;
              const prevCount = i > 0 ? data[i - 1].count : entry.count;
              const dropPercent = prevCount > 0 ? (prevCount - entry.count) / prevCount * 100 : 0;
              const isSignificantDrop = dropPercent > 30;
              let fill = `hsl(${185 - i * 6}, 80%, ${55 - i * 1.5}%)`;
              if (isSignificantDrop && i > 0) fill = '#f59e0b';
              return <Cell key={i} fill={fill} data-id="element-37" />;
            })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>;
}